import React, {useState, useEffect} from 'react'
import { Col, Row } from 'olive-react-myoneui';
import Container from 'olive-react-myoneui/lib/Container';

function SomethingWentWrong({ className }) {
    useEffect(() => {
        setTimeout(() => {
            if(document.getElementById("something-went-wrong")) document.getElementById("something-went-wrong").classList.remove("d-none");
        }, 30000);
    })
    return (
        <div className={`${className || ''} d-flex align-items-center justify-content-center d-none vh-100 text-center`} id="something-went-wrong">
            <Container>
                <Row>
                    <Col lg={12} className="mb-4">
                        <h1>
                            Something Went Wrong
                        </h1>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default SomethingWentWrong;